import { Award, Quote } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";

const AWARDS = [
  { body: "WICCI · Delhi Design Council", role: "President, appointed 2020" },
  { body: "WICCI · Iconic Women Award", role: "Honoured 2026", testid: "founder-award-2026-badge" },
];

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-meenu-gaur-section" className="py-24 lg:py-32 bg-sand relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <FadeUp className="lg:col-span-5" y={60}>
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div aria-hidden className="absolute -top-5 -left-5 right-5 -bottom-5 border border-brass/50" />
            <img
              src="/images/founder.jpg"
              alt="Meenu Gaur, Founder & Principal Designer of The Studio31"
              data-testid="founder-portrait-image"
              className="relative z-10 w-full aspect-[3/4] object-cover img-editorial"
              loading="lazy"
            />
            <span className="absolute z-20 bottom-5 -left-3 lg:-left-8 bg-ink text-cream px-5 py-3">
              <span className="block font-serif text-lg leading-none">Meenu Gaur</span>
              <span className="block text-[9px] tracking-widest2 uppercase text-brass mt-1.5">Founder &amp; Principal Designer</span>
            </span>
          </div>
        </FadeUp>

        <div className="lg:col-span-7">
          <FadeUp>
            <Eyebrow>Meet the Founder</Eyebrow>
            <h2 data-testid="founder-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink mt-5">
              Meenu Gaur
            </h2>
          </FadeUp>

          <FadeUp delay={0.08}>
            <div data-testid="founder-bio-text" className="mt-7 space-y-5 text-[15px] leading-relaxed text-espresso/80 max-w-2xl">
              <p>
                With nearly 19 years of experience, Meenu Gaur is an accomplished interior designer
                known for her creative vision, conceptual thinking and refined design sensibility.
              </p>
              <p>
                After a decade with leading firms — Mahagun Group, Ansal Housing &amp; Construction,
                Marks Dzyn and Taneja Interiors — she founded The Studio31 in 2018 to translate her
                distinctive design philosophy into thoughtfully crafted spaces.
              </p>
              <p>
                Her portfolio spans luxury residences, apartments, affordable homes, corporate,
                commercial and hospitality interiors — balancing sophistication, functionality,
                innovation and timeless aesthetics.
              </p>
            </div>
          </FadeUp>

          <FadeUp delay={0.14}>
            <div className="grid sm:grid-cols-2 gap-4 mt-9">
              {AWARDS.map((a) => (
                <div
                  key={a.body}
                  data-testid={a.testid || "founder-award-2020-badge"}
                  className="border border-hairline bg-cream p-6 flex items-start gap-4 hover:border-brass/50 transition-colors duration-300"
                >
                  <Award size={20} className="text-brass-deep shrink-0 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-ink">{a.body}</p>
                    <p className="text-xs text-taupe mt-1.5">{a.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </FadeUp>

          <FadeUp delay={0.2}>
            <div className="mt-10 border-l-2 border-brass pl-6 lg:pl-8">
              <Quote size={20} className="text-brass mb-3" />
              <p data-testid="founder-quote-text" className="font-serif italic text-xl lg:text-2xl text-ink leading-snug max-w-xl">
                "We create spaces that are not only beautiful, but purposeful, personal and
                enduring."
              </p>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
